// src/belediye/pages/sohbet/SohbetDetayPage.js
//
// FAZ-94 — SOHBET DETAYI TAM EKRAN BİR ROTA.
//
// Kullanıcı: "Mesajların detay sayfasında kesinlikle ne üstteki navbar ne
// alttaki navbar görünmeyecek. Sadece yukarıdaki kısımda sohbet adı olsun,
// sol tarafta geri butonu, yanında profil fotoğrafları ve sohbet adı, sağ
// tarafta da 3 nokta yapısı."
//
// Bu yerleşimin TAMAMI zaten `ChatThread`'in kendi başlık barında var
// (geri · avatar · ad/alt satır · ⋮). Bu sayfa yeni bir başlık ÇİZMİYOR;
// yalnız ona tam ekran bir kap veriyor ve kabuğu susturuyor.
//
// Kabuğu susturma yolu `data-msj-ekran="detay"` bayrağı: alt bar bu bayrağı
// zaten okuyordu (FAZ-92, AltBar.css). Navbar da aynı bayraktan gizleniyor —
// bayrak <html>'de, sayfa kabuğun içinde: React ağacından birbirlerini
// göremezler, sistemin bu deseni zaten var (data-msj-dock, data-gk-detay).

import React, { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import ChatThread from "../../components/mesajlasma/ChatThread";
import { sonKabukRotasi } from "../../components/AltBar";
import "../../components/mesajlasma/chat.css";
import "./sohbet.css";

export default function SohbetDetayPage() {
  const { conversationId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  /* FAZ-94 §3 — KABUK SUSAR: üst navbar yok, alt bar yok, içerik dolgusuz. */
  useEffect(() => {
    const kok = document.documentElement;
    kok.setAttribute("data-msj-ekran", "detay");
    return () => kok.removeAttribute("data-msj-ekran");
  }, []);

  /* FAZ-94 §5 — GERİ NEREYE?
     Sıra: (1) bu sayfaya gelirken taşınan `donus` (talep detayından geldiyse
     oraya döner — kullanıcı: "başvuru detay sayfasından geldiğimiz için oraya
     gitsin"), (2) tarayıcı geçmişi, (3) alt barda en son bulunulan kabuk
     rotası, (4) sohbet listesi.

     (3) gerekli çünkü bildirimden ya da SMS'ten gelindiğinde geçmiş BOŞtur;
     `navigate(-1)` kullanıcıyı uygulamanın dışına atardı. */
  const donus = location.state?.donus || null;
  const geri = () => {
    if (donus) {
      navigate(donus);
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(sonKabukRotasi() || "/yonetim/sohbet");
  };

  return (
    <div className="sohbet-detay">
      <ChatThread
        key={conversationId}
        conversationId={Number(conversationId)}
        variant="page"
        onBack={geri}
        /* Sohbet silinince listeye dön — bulunduğumuz kayıt artık yok. */
        onHidden={() => navigate("/yonetim/sohbet", { replace: true })}
        /* Sohbet içinden başka bir sohbete geçilirse (görev akışı yeni sohbet
           doğurabiliyor) adres çubuğu da onu göstermeli. `replace`: kullanıcı
           geri tuşuyla artık var olmayan ara duruma dönmesin. */
        onSwitchConversation={(id) =>
          navigate(`/yonetim/sohbet/${id}`, { replace: true, state: { donus } })
        }
      />
    </div>
  );
}
